






import { EventBus } from '@/helpers/EventBus';
import {Watch, Component, Vue} from 'vue-property-decorator';
import { DisplayMode } from './ItemsListDashboard.vue';

@Component
export default class SearchBar extends Vue {

  public static readonly PLACEHOLDER_ORDERS: string = 'N° de commande';
  public static readonly PLACEHOLDER_PRODUCTS: string = 'CUG / Nom du produit';

  public searchTerms: string = "";
  public placeholder: string = SearchBar.PLACEHOLDER_ORDERS;

  created() {
    EventBus.$on(EventBus.TOGGLE_DISPLAY, (display: DisplayMode) => {
      this.placeholder = display === DisplayMode.ORDERS ? SearchBar.PLACEHOLDER_ORDERS : SearchBar.PLACEHOLDER_PRODUCTS;
    })
  }

  @Watch('searchTerms')
  onSearchTermsChanged() {
    EventBus.$emit(EventBus.UPDATE_SEARCH, this.searchTerms);
  }
}
